<template>
  <v-container class="in-product-banner px-0 py-0" fluid>
    <div
      v-if="!hideBanner"
      style="min-height: 140px; background-size: cover"
      :style="{
        'background-image': `url(${require('@/assets/images/activate_6/activate-banner-background-4.png')})`,
      }"
    >
      <v-row no-gutters>
        <v-col cols="5" style="min-height: 140px" class="d-flex justify-center">
          <v-img
            class="ma-auto"
            max-height="100"
            max-width="350"
            :src="require('@/assets/images/activate_6/activate-6-catch-up.png')"
          />
        </v-col>
        <v-col cols="6" class="pl-2 pl-lg-0">
          <div
            class="white--text pt-3 pb-1"
            style="line-height: initial; font-size: 16px"
          >
          &nbsp;
          </div>
          <div class="text-right">
            <v-btn
              class="gradient-btn white--text rounded font-weight-bold"
              tile
              large
              href="https://invt.io/1lxbal36rm4"
              target="_blank"
            >
              Watch on-demand
            </v-btn>
          </div>
        </v-col>
        <v-col cols="1" class="pt-2" align="center">
          <v-btn
            style="background: rgba(255, 255, 255, 0.5)"
            fab
            x-small
            rounded
          >
            <v-icon color="white" @click="hideActivateBanner">
              mdi-close-thick
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
// import SvgIcon from '@/components/SvgIcon'

export default {
  // components: { SvgIcon },
  data() {
    return {
      // Hide the banner now the event is over...
      // hideBanner: !!window.localStorage.getItem('gleaninHideActivate6CatchUp'),
      hideBanner: true,
    }
  },
  computed: {},
  methods: {
    hideActivateBanner() {
      window.localStorage.setItem('gleaninHideActivate6CatchUp', true)
      this.hideBanner = true
    },
  },
}
</script>

<style scoped>
.gradient-btn {
  background-image: linear-gradient(90deg, #c700de 0%, #503af8 100%);
  font-size: 16px;
  font-weight: 400;
  font-family: 'Catamaran', sans-serif;
  letter-spacing: 0.03em;
  margin-top: 25px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

</style>
